<div class="doc-modal-overlay" (click)="close()">
  <div class="doc-modal-card" (click)="$event.stopPropagation()">
    <button type="button" class="doc-modal-close" (click)="close()" aria-label="Fechar">
      <ion-icon name="close"></ion-icon>
    </button>
    <div class="doc-modal-header">
      <ion-icon [name]="isCheckoutContext ? 'card-outline' : 'document-text-outline'" class="doc-modal-icon"></ion-icon>
      <h2 class="doc-modal-title">{{ isCheckoutContext ? 'Documento para pagamento' : 'Complete seu cadastro' }}</h2>
      <p class="doc-modal-subtitle">{{ isCheckoutContext ? 'Informe seu CPF ou CNPJ para continuar com a forma de pagamento.' : 'Informe seu CPF ou CNPJ para completar seu cadastro na plataforma.' }}</p>
    </div>

    <div class="doc-type-select">
      <button
        type="button"
        class="doc-type-btn"
        [class.selected]="docType === 'CPF'"
        (click)="selectType('CPF')">
        <ion-icon name="person-outline"></ion-icon>
        CPF
      </button>
      <button
        type="button"
        class="doc-type-btn"
        [class.selected]="docType === 'CNPJ'"
        (click)="selectType('CNPJ')">
        <ion-icon name="business-outline"></ion-icon>
        CNPJ
      </button>
    </div>

    <form [formGroup]="form" class="doc-modal-form">
      <ion-item class="doc-modal-input" lines="none">
        <ion-icon [name]="docType === 'CPF' ? 'person-outline' : 'business-outline'" slot="start"></ion-icon>
        <input
          class="doc-modal-input-native"
          formControlName="documentNumber"
          type="tel"
          [placeholder]="docType === 'CPF' ? '000.000.000-00' : '00.000.000/0000-00'"
          [mask]="documentMask"
          [attr.inputmode]="'numeric'"
          (input)="errorMessage = ''"
        />
      </ion-item>
    </form>

    <p class="doc-modal-error" *ngIf="errorMessage">{{ errorMessage }}</p>
    <div class="doc-modal-loading" *ngIf="loading">
      <ion-spinner name="crescent"></ion-spinner>
      <span>{{ isCheckoutContext ? 'Cadastrando...' : 'Salvando...' }}</span>
    </div>

    <div class="doc-modal-actions">
      <ion-button
        expand="block"
        class="doc-modal-btn-submit"
        (click)="submit()"
        [disabled]="form.invalid || loading">
        <ion-icon name="checkmark-circle-outline" slot="start"></ion-icon>
        {{ isCheckoutContext ? 'Continuar' : 'Salvar' }}
      </ion-button>
    </div>
  </div>
</div>
